import { FooterStyle } from './style'

export const Footer = () => {
  return(
    <FooterStyle>
      <p>Desenvolvido pela equipe de Suporte de Tecnologia da Informação da SECONT. </p>
    </FooterStyle>
  );
}